import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'visualTranslationTabOpened',
  'visualTranslationOfferShown',
  'visualTranslationUnavailableShown',
  'visualTranslationStartClick',
  'visualTranslationStarted',
  'visualTranslationStartFailed',
  'visualTranslationCompleted',
  'visualTranslationFailed',
  'visualTranslationFailedShown',
  'visualTranslationRestartClick',
  'visualTranslationVideoView',
  'visualTranslationVideoDownload',
  'visualTranslationDraftDownload',
  'visualTranslationEditClick',
  'visualTranslationUploadToggle',
] as const;

export const visualTranslationEvents = getMappedEvents([...EVENTS], { shouldSendSubscriptionData: true });
